// src/utils/blockedWords.js

// These are matched as substrings — clear slurs with no legitimate use
const SUBSTRING_BLOCKED = [
  // Racial slurs
  'nigger','nigga','nigg','chink','gook','spic','spick','wetback','beaner',
  'kike','hymie','raghead','towelhead','sandnigger','redskin','squaw',
  'zipperhead','coon','jigaboo','porcmonkey','junglebunny','cottonpicker',
  'cracker','whitey','honky','gringo',

  // Homophobic / transphobic
  'faggot','fag','dyke','tranny','shemale','ladyboy',

  // Sexist / misogynistic
  'cunt','twat','slut','whore','skank',

  // General profanity
  'fuck','fucker','fucking','fuk','f*ck',
  'shit','shithead','bullshit',
  'ass','asswipe','jackass',
  'dickhead','prick',
  'pussy','clit',
  'bastard','motherfucker','mfer',

  // Nazi / extremist
  'nazi','hitler','heil','kkk','whitepride','whitepower',
  'neonazi','1488','siegheil',

  // Drug references
  'crackhead','junkie','methhead',

  // Leet-speak
  'f4gg0t','n1gg3r','n1gga','fvck','sh1t','@ss','b1tch',
];

// These are matched as whole words + plurals — have legitimate uses as substrings
const WHOLE_WORD_BLOCKED = [
  'bitch','cock','dick','homo','hoe','damn','hell',
  'wtf','stfu','88','negro',
];

export const isBadUsername = (name) => {
  if (!name) return false;
  const cleaned = name.toLowerCase().replace(/[\s_.\-*@!]/g, '');

  // Substring check
  if (SUBSTRING_BLOCKED.some(word => cleaned.includes(word.replace(/\s/g, '')))) {
    return true;
  }

  // Whole word check — catches plurals and camelCase
  const lower = name.toLowerCase();
  const cleaned2 = lower.replace(/[\s_.\-*@!0-9]/g, '');
  if (WHOLE_WORD_BLOCKED.some(word => {
    const regex = new RegExp(`\\b${word}`, 'i');
    return regex.test(lower) || cleaned2.includes(word);
  })) {
    return true;
  }

  return false;
};